<script lang="ts">
    import { PRODUCT_VARIANT_DEFAULT_TITLE } from "@/constants";
    import NoProductIcon from "@apps/reviews/components/icons/NoProductIcon.svelte";
    import UnavailableProductEntity from "@modules/products/entities/UnavailableProductEntity";

    import Icon from "@components/Icon.svelte";
    import Image from "@components/Image/Image.svelte";
    import Money from "@components/Money.svelte";

    export let product: UnavailableProductEntity;
</script>

<div class="gw-rv-product">
    <div class="gw-rv-product__inner">
        <div class="gw-rv-product__info">
            <div class="gw-rv-product__left">
                {#if product?.imageUrl}
                    <Image
                        src={product?.imageUrl + "&width=128" || ""}
                        alt={product?.title || ""}
                        blur
                        imgClassName="gw-rv-product__image"
                        objectFit="contain"
                    />
                {:else}
                    <Icon width="60" height="60" viewBox="0 0 60 60">
                        <NoProductIcon />
                    </Icon>
                {/if}
            </div>
            <div class="gw-rv-product__center">
                <h4 class="gw-rv-product__title">
                    {product.title}
                </h4>
                {#if product?.title !== PRODUCT_VARIANT_DEFAULT_TITLE}
                    <h5 class="gw-rv-product__sub-title">
                        {product?.title}
                    </h5>
                {/if}

                {#if product?.price}
                    <span class="gw-rv-product__price">
                        <Money amount={product?.price} />
                    </span>
                {/if}
            </div>
        </div>
    </div>
</div>

<style lang="postcss">
    .gw-rv-product {
        background-color: inherit;

        &__inner {
            border-top: 1px solid #f0f0f0;
            padding: 1.25em 0;
            display: flex;
            justify-content: space-between;

            @media all and (max-width: 600px) {
                padding: 1em 0;
            }
        }

        &__info {
            width: 100%;
            display: flex;
            justify-content: space-between;
            gap: 0.75em;
            align-items: center;
            flex-wrap: wrap;
        }

        &__left {
            width: 60px;
            height: 60px;
        }

        &__center {
            flex: 1;
        }

        &__title {
            margin: 0;
            font-size: 0.875em;
            line-height: normal;
            font-weight: 600;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        &__sub-title {
            margin: 2px 0 0;
            font-size: 0.75em;
            line-height: normal;
            font-weight: 400;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }

        &__price {
            margin-top: 0.625em;
            display: inline-block;
            font-size: 0.75em;
        }
    }

    :global(.gw-rv-product__image) {
        border-radius: 3px;
        box-sizing: border-box;
        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    }
</style>
